import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {CancellationReasonVisibilitiesType} from "../../types/cancellationReasonVisibilities.type";
import {ServiceType} from "../../../deliveries/types/service.type";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {CancellationReasonType} from "../../types/cancellation-reason.type";

export class cancellationReasonSelectCtrl implements IController {

  selectedCancellationReason: any;
  serviceTypes: ServiceType[];
  excludeIds: any;
  disable: any;
  cancellationSourceTypes: CancellationReasonVisibilitiesType[];
  ngPlaceholder: any;
  noUnderline: any;
  types: CancellationReasonType[];
  isRequired: boolean;
  onChange: Function;

  private cancellationReasonsRef: any;
  private searchTerm = '';
  private cancellationReasons: any;

  /* @ngInject */
  constructor(private $mdSelect,
              private $log, private $q: IQService, private commonsAlertsService: CommonsAlertsService, private $cancellationReasons) {
  }

  $onInit() {
    this.cancellationReasonsRef = this.$cancellationReasons();

    if (!this.excludeIds) {
      this.excludeIds = [];
    }

    this._getCancellationReasons();
  }

  cancel() {
    this.$mdSelect.hide();
  }

  reset() {
    this.searchTerm = '';
    this.selectedCancellationReason = undefined;
    this.onChange({selectedCancellationReason: this.selectedCancellationReason})
    this.$mdSelect.hide();
  }

  private _getCancellationReasons() {
    return this.cancellationReasonsRef.$getAll({cancellationReasonVisibilities: this.cancellationSourceTypes})
      .then((ids) => {
        return this.cancellationReasonsRef.$asyncValues(ids);
      })
      .then((cancellationReasons) => {
        if (this.excludeIds.length) {
          cancellationReasons = _.filter(cancellationReasons, (b) => {
            return _.indexOf(this.excludeIds, b.id) === -1;
          });
        }
        this.cancellationReasons = !this.types ? cancellationReasons : _.filter(cancellationReasons, (cr) => {
          return _.includes(this.types, cr.typeToCancel);
        });
      })
      .catch((error) => {
        this.commonsAlertsService.somethingWentWrongError();
        this.$log.error('Failed to get service areas @branchesMultiSelect@onOpen', error);
      })
  }

}

angular
  .module('bringoz.admin.cancellation-reasons')
  .component('cancellationReasonSelect', {
    bindings: {
      selectedCancellationReason: '<',
      serviceTypes: '<',
      types: '<?',
      excludeIds: '<?',
      disable: '<',
      cancellationSourceTypes: '<',
      isRequired: '<?',
      ngPlaceholder: '@?',
      noUnderline: '@?',
      onChange: '&'
    },
    template: require('./cancellation-reason-select.html').default,
    controller: cancellationReasonSelectCtrl
  });

